export enum MultiBrokerLoginTypesEnum {
  SIMULADOR = 0,
  MULTIBROKER = 1
}
